import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import AdminDashboard from './components/AdminDashboard';
import './App.css';

// Main App component - Email Campaign System Only
const App: React.FC = () => {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Email Admin Dashboard */}
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/app/admin" element={<AdminDashboard />} />

          {/* Default redirect to admin */}
          <Route path="/" element={<Navigate to="/admin" />} />
          <Route path="/app" element={<Navigate to="/app/admin" />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;
